<template>
  <section class="fs-stats statistics">
    <Breadcrumbs
      :breadcrumbs="[
        { title: $t('menu.statistics'), disabled: true },
        { title: $t('menu.fsstatistics'), disabled: true }
      ]">
    </Breadcrumbs>

    <form class="evollu-form">

      <div class="row" v-if="clusters.length">
        <div class="col-12 col-sm-5">
          <va-switch v-model="filters.showEntityStats">
            <span slot="trueTitle">{{$t('kiosks.entity')}}</span>
            <span slot="falseTitle">
              <span>
                {{$t('statistics.cluster')}}
              </span>
              <span v-if="!filters.showEntityStats && filters.cluster" @click.prevent="expandCluster = !expandCluster" class="cluster-dropdown">
                <i class="fa" :class="{'fa-chevron-up': expandCluster, 'fa-chevron-down': !expandCluster}"></i>
              </span>
            </span>
          </va-switch>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-5">
          <span v-if="filters.showEntityStats">
            <label class="form-label">{{$t('statistics.select_entity')}}:</label>
            <multiselect
              id="entities-multiselect"
              v-model="filters.entity"
              :options="entityOptions"
              track-by="id"
              :custom-label="formatedEntityLabel"
              :placeholder="!entityOptions.length ? $t('statistics.no_entities') : $t('statistics.totalValues')"
              :allow-empty="false"
              :multiple="false"
              :searchable="true"
              :disabled="entityOptions.length < 2"
            >
              <span slot="noResult">{{$t('patients.noResults')}}</span>
              <template slot="clear" slot-scope="props" v-if="entityOptions.length > 1 && filters.entity !== null">
                <div id="entities-multiselect-clear" class="multiselect__clear" @mousedown.prevent.stop="filters.entity = null"></div>
              </template>
            </multiselect>
          </span>

          <span v-else>
            <label class="form-label">{{$t('statistics.select_cluster')}}:</label>
            <multiselect
              id="clusters-multiselect"
              v-model="filters.cluster"
              :options="clusterOptions"
              track-by="id"
              :custom-label="formatedEntityLabel"
              :placeholder="!clusterOptions.length ? $t('statistics.no_clusters') : $t('statistics.totalValues')"
              :allow-empty="false"
              :multiple="false"
              :searchable="true"
              :disabled="clusterOptions.length < 2"
            >
              <span slot="noResult">{{$t('patients.noResults')}}</span>
              <template slot="clear" slot-scope="props" v-if="clusterOptions.length > 1 && filters.cluster !== null">
                <div id="clusters-multiselect-clear" class="multiselect__clear" @mousedown.prevent.stop="filters.cluster = null"></div>
              </template>
            </multiselect>
          </span>
        </div>

        <div class="col-12 col-sm-4">
          <RangeDatePicker
            id="range-date-picker"
            :label="`${$t('statistics.date_interval')}:`"
            v-model="filters.dateRange"
            placeholder="---"
            :clearable="false"
            :disabled="isLoading"
          >
          </RangeDatePicker>
        </div>
      </div>

      <div v-if="!filters.showEntityStats && filters.cluster && expandCluster" class="row mb-5">
        <div class="col-12">
          <va-badge outline v-for="(name, index) in filters.cluster.entity_names" :key="index">
            {{name}}
          </va-badge>
        </div>
      </div>
    </form>

    <div v-show="isLoading" class="no-data-wrapper">
      <h6><b>{{$t('tables.loading')}}</b></h6>
      <LoadingAnimation :size="'5px'" class="d-flex justify-content-center pt-4 pb-4"></LoadingAnimation>
    </div>

    <div v-show="!isLoading && !entityOptions.length" class="no-data-wrapper">
      <span class="is-bold">{{$t('statistics.no_data_for_date_interval')}}</span>
    </div>

    <div v-show="!isLoading && entityOptions.length" class="row fs-stats-content">
      <div class="section col-sm-6 col-md-4">
        <h5 class="section-title">{{$t('statistics.registos')}}</h5>
        <div class="row">
          <div class="col-sm-6">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ kioskEntries }}
                  </div>
                  <div class="text-center">{{$t('statistics.kiosk_registers')}}</div>
                </div>
              </div>
            </va-card>
          </div>

          <div class="col-sm-6">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ counterEntries }}
                  </div>
                  <div class="text-center">{{$t('statistics.balcony_registers')}}</div>
                </div>
              </div>
            </va-card>
          </div>

          <div class="col-sm-6 cancelled-status">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ cancelledHtLoss + cancelledHtNoLoss }}
                  </div>
                  <div class="text-center">{{$t('fsstatistics.cancelled_tests')}}</div>
                </div>
              </div>
            </va-card>
          </div>

          <div class="col-sm-6 cancelled-status">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ contactsNoSuccessCount }}
                  </div>
                  <div class="text-center">{{$t('statistics.status.10')}}</div>
                </div>
              </div>
            </va-card>
          </div>

        </div>
        <div class="row">
          <div class="col-md-12">
            <va-card class="chart-widget">
              <va-chart
                :data="recordsData"
                :options="chartOptions"
                type="donut"
              ></va-chart>
            </va-card>
          </div>
        </div>
      </div>
      <div class="section col-sm-6 col-md-4">
        <h5 class="section-title">{{$t('statistics.consultations')}}</h5>
        <div class="row">

          <div class="col-sm-6">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ contactsPostponedCount }}
                  </div>
                  <div class="text-center">{{$t('statistics.status.12')}}</div>
                </div>
              </div>
            </va-card>
          </div>

          <div class="col-sm-6">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ convertedToAppointmentCount }}
                  </div>
                  <div class="text-center">{{$t('statistics.status.100')}}</div>
                </div>
              </div>
            </va-card>
          </div>

          <div class="col-sm-6">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ appointmentMissedCount }}
                  </div>
                  <div class="text-center">{{$t('statistics.status.105')}}</div>
                </div>
              </div>
            </va-card>
          </div>

          <div class="col-sm-6">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ totalAppointments }}
                  </div>
                  <div class="text-center">
                    <va-popover
                      placement="bottom"
                      :message="$t('statistics.consultations_made_tooltip')">
                      {{$t('statistics.consultations_made')}}
                      <i class="fa fa-info-circle"></i>
                    </va-popover>
                  </div>
                </div>
              </div>
            </va-card>
          </div>

          <!-- <div class="col-sm-5ths final-status small-stats">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number small-number">
                    <i class="text-primary stats-icon"></i>
                    {{ appointmentNotApplicableCount }}
                  </div>
                  <div class="text-center">{{$t('statistics.status.101')}}</div>
                </div>
              </div>
            </va-card>
          </div>

          <div class="col-sm-5ths final-status small-stats">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number small-number">
                    <i class="text-primary stats-icon"></i>
                    {{ appointmentNoSaleCount }}
                  </div>
                  <div class="text-center">{{$t('statistics.status.102')}}</div>
                </div>
              </div>
            </va-card>
          </div>

          <div class="col-sm-5ths final-status-success small-stats">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number small-number">
                    <i class="text-primary stats-icon"></i>
                    {{ appointmentEntCount }}
                  </div>
                  <div class="text-center">{{$t('statistics.status.106')}}</div>
                </div>
              </div>
            </va-card>
          </div>

          <div class="col-sm-5ths small-stats">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number small-number">
                    <i class="text-primary stats-icon"></i>
                    {{ appointmentPossibleSaleCount }}
                  </div>
                  <div class="text-center">{{$t('statistics.status.103')}}</div>
                </div>
              </div>
            </va-card>
          </div>

          <div class="col-sm-5ths small-stats">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number small-number">
                    <i class="text-primary stats-icon"></i>
                    {{ trialCount }}
                  </div>
                  <div class="text-center">{{$t('statistics.status.104')}}</div>
                </div>
              </div>
            </va-card>
          </div> -->

        </div>
        <div class="row">
          <div class="col-md-12">
            <va-card class="chart-widget">
              <va-chart
                :data="appointmentsData"
                :options="chartOptions"
                type="donut"
              ></va-chart>
            </va-card>
          </div>
        </div>
      </div>
      <div class="section col-sm-6 col-md-4">
        <h5 class="section-title">{{$t('statistics.sales')}}</h5>
        <div class="row">
          <div class="col-sm-12">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ qualifiedCount }}
                  </div>
                  <div class="text-center">
                    <va-popover
                      placement="bottom"
                      :message="$t('statistics.qualified_leads_tooltip')">
                      {{$t('pyramid.lqe')}}
                      <i class="fa fa-info-circle"></i>
                    </va-popover>
                  </div>
                </div>
              </div>
            </va-card>
          </div>
          <div class="col-sm-12 final-status-success">
            <va-card>
              <div class="info-widget-inner">
                <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ buysCount }}
                  </div>
                  <div class="text-center">{{$t('statistics.status.110')}}</div>
                </div>
              </div>
            </va-card>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <va-card class="chart-widget">
              <va-chart
                :data="finalStatusData"
                :options="chartOptions"
                type="donut"
              ></va-chart>
            </va-card>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import { StatisticsService } from '@/api/LeadsService'
import Breadcrumbs from '@/components/common/Breadcrumbs'
import { FS_STATS } from '@/local-storage/LocalStorageKeys'
import RangeDatePicker from '@/components/common/RangeDatePicker'
import LocalStorageHelper from '@/local-storage/LocalStorageHelper'
import MultiselectLabelFormatter from '@/mixins/MultiselectLabelFormatter'
import LoadingAnimation from '@/components/users/components/Helpers/LoadingAnimation'

export default {
  components: {
    Breadcrumbs,
    Multiselect,
    RangeDatePicker,
    LoadingAnimation
  },
  mixins: [
    MultiselectLabelFormatter
  ],
  data () {
    return {
      chartOptions: {
        cutoutPercentage: 70,
        legend: {
          position: 'bottom',
          labels: {
            fontColor: this.$store.getters.palette.fontColor,
            fontFamily: 'sans-serif',
            fontSize: 14,
            padding: 20,
            usePointStyle: true
          }
        },
        tooltips: {
          bodyFontSize: 14,
          bodyFontFamily: 'sans-serif'
        },
        responsive: true,
        maintainAspectRatio: false
      },
      expandCluster: false,
      isLoading: false,
      dataset: {},
      totalValues: null,
      filters: {
        showEntityStats: true,
        entity: null,
        cluster: null,
        dateRange: {
          start: this.moment().subtract(1, 'months').format('YYYY-MM-DD'),
          end: this.moment().format('YYYY-MM-DD')
        }
      }
    }
  },
  methods: {
    loadBaseData () {
      this.isLoading = true
      StatisticsService.getFsStats(this.requestParams)
        .then(originalData => this.createDataset(originalData))
        .catch((error) => {
          console.log(error)
          this.showToast(this.$t('statistics.something_went_wrong'), this.$store.state.errorToastOptions)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    createDataset: function (data) {
      this.dataset = {}
      this.totalValues = null

      if (data.length) {
        data
          .sort((a, b) => a.id - b.id)
          .forEach(element => {
            this.dataset[element.id] = this.createDatasetEntry(element)
          })

        this.totalValues = this.calculateAggregateData(Object.keys(this.dataset))
      }
    },
    calculateAggregateData: function (entityIds) {
      let aggregate = this.createDatasetEntry()
      const keys = Object.keys(aggregate)
      aggregate.entities = 0

      entityIds.forEach(entityId => {
        if (this.dataset.hasOwnProperty(entityId)) {
          let element = this.dataset[entityId]

          keys.forEach(key => {
            aggregate[key] += element[key]
          })

          if (element.kiosk_ht > 0 || element.cancelled > 0 || element.kiosk > 0 || element.counter > 0 || element.app > 0 || element.web > 0) {
            aggregate.entities++
          }
        }
      })

      return aggregate
    },
    createDatasetEntry: function (data = {}) {
      return {
        counter: 0,
        kiosk: 0,
        kiosk_ht: 0,
        kiosk_ht_loss: 0,
        questionnaires: 0,
        contacts_no_success: 0,
        contacts_success: 0,
        contacts_success_hl: 0,
        contacts_postponed: 0,
        requested_appointment: 0,
        converted_to_appointment: 0,
        appointment_not_applicable: 0,
        appointment_no_sale: 0,
        appointment_possible_sale: 0,
        trial: 0,
        qualified: 0,
        appointment_missed: 0,
        appointment_ent: 0,
        sale: 0,
        cancelled: 0,
        cancelled_ht_loss: 0,
        cancelled_ht_no_loss: 0,
        sessions: 0,
        ...data
      }
    },
    getFullEntityById: function (id) {
      return this.fullEntities.find(e => e.id === id)
    },
    loadLocalStorage: function () {
      return new Promise((resolve, reject) => {
        const state = LocalStorageHelper.get(FS_STATS)
        if (state !== null) {
          this.filters = {
            ...this.fitlers,
            ...state
          }
        }
        resolve()
      })
    }
  },
  computed: {
    ...mapGetters([
      'clusters'
    ]),
    audiologyService: function () {
      return this.$store.state.services.find(service => service.url === this.$store.state.evollead_server)
    },
    fullEntities: function () {
      return this.audiologyService ? this.audiologyService.entities : []
    },
    requestParams: function () {
      return {
        from: this.filters.dateRange.start,
        until: this.filters.dateRange.end
      }
    },
    stats: function () {
      if (this.filters.showEntityStats && this.filters.entity) {
        return this.dataset[this.filters.entity.id]
      } else if (!this.filters.showEntityStats && this.filters.cluster) {
        return this.calculateAggregateData(this.filters.cluster.entitiesIds)
      } else {
        return this.totalValues
      }
    },
    entityOptions: function () {
      return Object.values(this.dataset)
        .map(element => {
          let entity = this.getFullEntityById(element.id)
          return {
            id: element.id,
            name: element.name,
            cities: entity ? entity.cities : []
          }
        })
    },
    clusterOptions: function () {
      return this.clusters
        .map(cluster => {
          let entitiesWithPermissions = this.entityOptions.filter(entity => cluster.entitiesIds.some(entityId => entity.id === entityId))
          cluster.entitiesWithPermissions = entitiesWithPermissions.length
          cluster.entity_names = entitiesWithPermissions.map(e => e.name)
          return cluster
        })
        .filter(cluster => cluster.entitiesWithPermissions > 0)
    },
    baseRecordsValues: function () {
      if (this.stats) {
        return [
          this.stats.kiosk,
          this.stats.counter,
          this.stats.cancelled
        ]
      } else {
        return [0, 0, 0]
      }
    },
    recordsData () {
      return {
        labels: [
          this.$t('statistics.graph_label_kiosk'),
          this.$t('statistics.graph_label_counter'),
          this.$t('statistics.cancelled_tests')
        ],
        datasets: [{
          data: this.baseRecordsValues,
          backgroundColor: [
            '#5dceb3',
            '#a4d8cc',
            '#a3afaf'
          ]
        }]
      }
    },
    baseAppointmentsValues: function () {
      if (this.stats) {
        return [
          this.stats.appointment_possible_sale + this.stats.appointment_ent + this.stats.appointment_not_applicable + this.stats.appointment_no_sale + this.stats.trial + this.stats.sale,
          this.stats.converted_to_appointment,
          this.stats.appointment_missed,
          this.stats.contacts_success_hl,
          this.stats.contacts_success - this.stats.contacts_success_hl
        ]
      } else {
        return [0, 0, 0, 0, 0]
      }
    },
    appointmentsData () {
      return {
        labels: [
          this.$t('fsstatistics.consultations_made'),
          this.$t('fsstatistics.scheduled_appointments'),
          this.$t('pyramid.missedAppointment'),
          this.$t('fsstatistics.contacted_success_hl'),
          this.$t('fsstatistics.contacted_success_no_hl'),
        ],
        datasets: [{
          data: this.baseAppointmentsValues,
          backgroundColor: [
            '#279381',
            '#29C4A9',
            '#97E2D5',
            '#a3afaf',
            '#d8dcdc',
          ]
        }]
      }
    },
    baseFinalValues: function () {
      if (this.stats) {
        return [
          this.stats.appointment_not_applicable,
          this.stats.appointment_no_sale,
          this.stats.appointment_ent,
          this.stats.appointment_possible_sale,
          this.stats.trial,
          this.stats.sale
        ]
      } else {
        return [0, 0, 0, 0, 0, 0]
      }
    },
    finalStatusData () {
      return {
        labels: [
          this.$t('statistics.status.101'),
          this.$t('statistics.status.102'),
          this.$t('statistics.status.106'),
          this.$t('statistics.status.103'),
          this.$t('statistics.status.104'),
          this.$t('statistics.status.110'),
        ],
        datasets: [{
          data: this.baseFinalValues,
          backgroundColor: [
            '#266F62',
            '#279381',
            '#28B199',
            '#29C4A9',
            '#68D5C2',
            '#97E2D5'
          ]
        }]
      }
    },
    counterEntries: function () {
      return this.stats ? this.stats.counter : 0
    },
    kioskEntries: function () {
      return this.stats ? this.stats.kiosk : 0
    },
    ht: function () {
      return this.stats ? this.stats.kiosk_ht : 0
    },
    htLoss: function () {
      return this.stats ? this.stats.kiosk_ht_loss : 0
    },
    htNoLoss: function () {
      return this.stats ? this.stats.kiosk_ht : 0
    },
    contactsCount: function () {
      return this.stats ? this.stats.contacts_no_success + this.stats.contacts_success + this.stats.contacts_postponed : 0
    },
    contactsSuccessCount: function () {
      return this.stats ? this.stats.contacts_success : 0
    },
    contactsSuccessHLCount: function () {
      return this.stats ? this.stats.contacts_success_hl : 0
    },
    contactsSuccessNoHLCount: function () {
      return this.stats ? this.stats.contacts_success - this.stats.contacts_success_hl : 0
    },
    totalSuccessContacts: function () {
      return this.contactsSuccessCount + this.scheduledAppointments
    },
    contactsNoSuccessCount: function () {
      return this.stats ? this.stats.contacts_no_success : 0
    },
    contactsPostponedCount: function () {
      return this.stats ? this.stats.contacts_postponed : 0
    },
    convertedToAppointmentCount: function () {
      return this.stats ? this.stats.converted_to_appointment : 0
    },
    scheduledAppointments: function () {
      return this.convertedToAppointmentCount + this.totalAppointments + this.appointmentMissedCount
    },
    appointmentNotApplicableCount: function () {
      return this.stats ? this.stats.appointment_not_applicable : 0
    },
    appointmentNoSaleCount: function () {
      return this.stats ? this.stats.appointment_no_sale : 0
    },
    appointmentPossibleSaleCount: function () {
      return this.stats ? this.stats.appointment_possible_sale : 0
    },
    appointmentMissedCount: function () {
      return this.stats ? this.stats.appointment_missed : 0
    },
    appointmentEntCount: function () {
      return this.stats ? this.stats.appointment_ent : 0
    },
    totalAppointments: function () {
      return this.appointmentPossibleSaleCount +
            this.appointmentEntCount +
            this.appointmentNotApplicableCount +
            this.appointmentNoSaleCount +
            this.trialCount + this.buysCount
    },
    trialCount: function () {
      return this.stats ? this.stats.trial : 0
    },
    buysCount: function () {
      return this.stats ? this.stats.sale : 0
    },
    qualifiedCount: function () {
      return this.stats ? this.stats.qualified : 0
    },
    cancelledHtLoss: function () {
      return this.stats ? this.stats.cancelled_ht_loss : 0
    },
    cancelledHtNoLoss: function () {
      return this.stats ? this.stats.cancelled_ht_no_loss : 0
    },
    sessionEntries: function () {
      return this.stats ? this.stats.sessions : 0
    },
    consultationsWithLoss: function () {
      return this.qualifiedCount + this.appointmentEntCount
    }
  },
  watch: {
    entityOptions: {
      handler: function (options) {
        if (this.filters.entity && !options.some(option => option.id === this.filters.entity.id)) {
          this.filters.entity = null
        }
      },
      immediate: true
    },
    clusterOptions: {
      handler: function (options) {
        // Multiselect did not update label unless v-model was reset to null and then set again
        const previousValue = this.filters.cluster
        this.filters.cluster = null
        let newSelectedValue = null

        if (options.length === 1) {
          newSelectedValue = options[0]
        } else if (previousValue) {
          newSelectedValue = options.find(option => option.id === previousValue.id) || null
        }

        this.$nextTick(() => {
          this.filters.cluster = newSelectedValue
        })
      },
      immediate: true
    },
    filters: {
      handler: function () {
        LocalStorageHelper.set(FS_STATS, this.filters)
      },
      deep: true
    },
    'filters.showEntityStats': function (value) {
      if (!value && !this.clusters.length) {
        this.filters.showEntityStats = true
      }
    },
    requestParams: function (value) {
      this.loadBaseData()
    },
  },
  mounted () {
    this.loadLocalStorage()
      .then(() => {
        this.loadBaseData()
      })
  }
}
</script>

<style lang="scss">

.fs-stats-content {

  .va-card__body {
    overflow-x: unset;
  }

  .va-card.dashboard-stats-widgets {
    -webkit-box-shadow: 0 0 3px 0 rgba(52, 56, 85, 0.25);
    box-shadow: 0 0 3px 0 rgba(52, 56, 85, 0.25);
  }

  .va-card:not(.dashboard-stats-widgets) {
    height: calc(100% - 1.5rem);
  }

  .info-widget-inner {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;
    min-height: 100px !important;

    &.has-chart {
      justify-content: space-between;
    }

    .stats {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      height: 100%;
      min-height: 110px;
    }
  }

  i {
    padding-top: 5px;
  }
}

.stats-number {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 2.625rem;
  margin-bottom: 0.5rem;
  margin-top: 12px;

  &.small-number {
    font-size: 1.8rem;
    margin-top: 16px;
  }

  @media (min-width: 1600px) {
    &.small-number {
      font-size: 1.5rem;
    }
  }

  .stats-icon {
    font-size: 1.5625rem;
    position: absolute;
    top: 0.625rem;
    left: -1.25rem;

    &.icon-wide {
      left: -1.875rem;
    }
  }
}

.final-status .widget {
  background: #d8dcdc;
}

.cancelled-status .widget {
  background: #d8dcdc;
  color: #7d8888;
}

.final-status-success .widget {
  background: #5dceb3;
}

.no-data-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 25vh;
}
</style>
